import React from 'react';
import { observer } from 'mobx-react';

import qrImage from '../../assets/images/qr.png';
import Button from '../../components/UI/Button/Button';
import Image from '../../components/UI/Image/Image';

import classes from './intro.module.scss';

import { useStorage } from '@/models/Storage';
import bg1 from '@/assets/images/bg1.png';
import bg2 from '@/assets/images/bg2.png';
import { analytics, AnalyticsShow, prepareUrl } from '@/utils/analytics';

export const Intro = observer(() => {
    const { setStage, stage, transition, setTransition } = useStorage();

    return !transition && stage !== 'intro' ? null : (
        <section className={`${classes.intro} ${classes[stage]}`}>
            <div
                className={classes.content}
                onTransitionEnd={() => {
                    setTransition(false);
                }}
            >
                <Image src={bg1} className={`${classes.bg1} ${classes.mobile}`} />
                <h1>Моменты хорошего настроения</h1>
                <div className={classes.text}>
                    <p>
                        Ozon Моменты — это короткие видео, в&nbsp;которых люди делятся яркими
                        эпизодами из&nbsp;жизни и&nbsp;покупают товары за&nbsp;пару кликов.
                    </p>
                    <p>
                        Посмотрите несколько моментов и&nbsp;попробуйте угадать, о&nbsp;каких
                        товарах говорят авторы. Или&nbsp;сразу отправляйтесь в&nbsp;свою
                        персональную ленту публикаций в&nbsp;приложении Ozon.
                    </p>
                </div>
                <Button
                    text={'Начать игру'}
                    onClick={() => {
                        setTransition(true);
                        analytics(AnalyticsShow.StartGame);
                        setStage('quiz');
                    }}
                    colorScheme={'primary'}
                />
                <Button
                    text={'В Моменты'}
                    link={prepareUrl(
                        'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvh&pr=%random%',
                    )}
                    colorScheme={'secondary'}
                />
                <div className={classes.qr}>
                    <Image src={qrImage} />
                    <span>Просканируйте QR-код, чтобы открыть Моменты в&nbsp;приложении Ozon.</span>
                </div>
                <Image src={bg2} className={`${classes.bg2} ${classes.mobile}`} />
            </div>
        </section>
    );
});
